import { UNINITIALIZED } from 'ContentUtils/constants/RequestStatus';
export const getGlobalStylesFields = state => {
  var _state$resources$glob;
  return (_state$resources$glob = state.resources.globalStyles) === null || _state$resources$glob === void 0 ? void 0 : _state$resources$glob.fields;
};
export const getGlobalStylesOverrides = state => {
  var _state$resources$glob2;
  return (_state$resources$glob2 = state.resources.globalStyles) === null || _state$resources$glob2 === void 0 ? void 0 : _state$resources$glob2.overrides;
};
export const getGlobalStylesFetchStatus = state => {
  var _state$resources$glob3, _state$resources$glob4;
  return (_state$resources$glob3 = (_state$resources$glob4 = state.resources.globalStyles) === null || _state$resources$glob4 === void 0 ? void 0 : _state$resources$glob4.requestStatus) !== null && _state$resources$glob3 !== void 0 ? _state$resources$glob3 : UNINITIALIZED;
};